module.exports = __webpack_public_path__ + "assets/c2d14706bf5eb9dbf4e660426e8c786e.svg";